import {
  getToken
} from '@/utils/auth'
import bus from "@/utils/bus";
import request from '@/utils/request'

export function chatStream(cb, close, err) {
  var urlps = 'type=pc&'
  urlps += 'access_token=' + getToken()
  const eventSource = new EventSource(
    process.env.BASE_API + '/user/ai/ai/aiChatMjLogs/chatStream?' + urlps
  )

  eventSource.addEventListener('message', event => {
    const jsonData = JSON.parse(event.data)
    if (jsonData.status === "FAILURE") {
      bus.$emit("refreshCount");
    }
    cb(jsonData)
  })
  eventSource.addEventListener('error', error => {
    close()
    eventSource.close()
    console.log(error)
  })
  eventSource.__close = () => {
    eventSource.__CLOSED = true
    eventSource.close()
  }
  return eventSource
}

export function send(data) {
  return request({
    url: '/user/ai/ai/aiChatMjLogs/send',
    method: 'post',
    data
  })
}
export function sendStatus(data) {
  return request({
    url: '/user/ai/ai/aiChatMjLogs/getStatus',
    method: 'post',
    data
  })
}

export function ruleList() {
  return request({
    url: '/user/user/ai/aiMjpromptConfig/list',
    method: 'post'

  })
}


export function getDemoFlag() {
  return request({
    url: '/user/user/user/userChatContent/getDemoFlag',
    method: 'post'

  })
}


export function propTabList() {
  return request({
    url: '/user/user/user/userChatContent/getCommonPromptTypeList',
    method: 'post'

  })
}
// export function propDetail(data) {
//   return request({
//     url: 'user/user/user/userChatContent/getCommonPromptList',
//     method: 'post',
//     data

//   })
// }


export function propDetail(data) {
  return request({
    url: '/user/user/user/userChatContent/getCommonPromptList',
    method: 'post',
    data,
    loading: false,
    transformRequest: (data) => {
      const param = new FormData()
      for (var k in data.data) {
        param.append(k, data.data[k])
      }
      for (const it in data) {
        if (data[it] !== undefined) {
          param.append(it, data[it])
        }
      }
      return param
    },

    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
export function SDruleList(data) {
  return request({
    url: '/user/user/ai/aiSdpromptConfig/list',
    method: 'post',
    data

  })
}

export function SDgetDetail(data) {
  return request({
    url: '/user/user/ai/aiSdpromptConfig/getDetail',
    method: 'post',
    data,
    loading: false,
    transformRequest: (data) => {
      const param = new FormData()
      for (var k in data.data) {
        param.append(k, data.data[k])
      }
      for (const it in data) {
        if (data[it] !== undefined) {
          param.append(it, data[it])
        }
      }
      return param
    },

    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}



export function getDetail(data) {
  return request({
    url: '/user/user/ai/aiMjpromptConfig/getDetail',
    method: 'post',
    data,
    loading: false,
    transformRequest: (data) => {
      const param = new FormData()
      for (var k in data.data) {
        param.append(k, data.data[k])
      }
      for (const it in data) {
        if (data[it] !== undefined) {
          param.append(it, data[it])
        }
      }
      return param
    },

    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/ai/AiChatMjLogs.js